export default "__VITE_ASSET__02e62918__"